<template>
  <a-layout class="height-100">
    <img class="logo logo-center absolute top-0 left-0 m2" src="@/assets/logo.png" />
    <div class="height-100 mobile-card mobile-snap-bottom">
      <a-layout class="height-100">
        <a-layout-content >
          <a-row type="flex" justify="space-around" align="middle" class="height-100" >
            <a-col :span="24" :sm="16" :md="14" :lg="10" class="center">
              <h1 class="white left-align">Personal Details</h1>
              <a-card class="card left-align">
                <a-form layout="vertical">
                  <a-form-item label="First Name">
                    <a-input type="text" v-model="firstName" placeholder="Your First Name"></a-input>
                  </a-form-item>
                  <a-form-item label="Last Name">
                    <a-input type="text" v-model="lastName" placeholder="Your Last Name"></a-input>
                  </a-form-item>
                  <a-form-item label="Institution">
                    <a-auto-complete v-model="institution" :dataSource="institutionOptions" :filterOption="filterOption"  placeholder="Your Institution"/>
                  </a-form-item>
                  <a-form-item class="mb0 right">
                    <a-button size="large" type="primary" :disabled="!isReady" :loading="loading" @click="onSubmit">Submit<a-icon type="right"/></a-button>
                  </a-form-item>
                </a-form>
              </a-card>
            </a-col>
          </a-row>
        </a-layout-content>
      </a-layout>
    </div>
  </a-layout>
</template>

<script>
import firebase from 'firebase';

export default {
  name: 'Login',
  data() {
    return {
      firstName: '',
      lastName: '',
      institution: '',
      institutionList: [],
      loading: false
    }
  },
  computed: {
    isReady() {
      return this.firstName && this.lastName && this.institution.length;
    },
    institutionOptions() {
      return this.institutionList.map(({ name }) => name);
    }
  },
  methods: {
    onSubmit() {
      this.loading = true;
      this.$db.collection('users').doc(this.$user.uid).set({
        institution: this.institutionList.find(({ name }) => name === this.institution).value,
        firstName: this.firstName,
        lastName: this.lastName
      }, { merge: true }).then((user) => {
        this.loading = false;
        this.$router.push('dashboard');
      }).catch((err) => {
        this.loading = false;
        console.log('err!', err)
        this.$message.error('Issue saving. Try again.');
      })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toUpperCase().indexOf(input.toUpperCase()) >= 0
    }
  },
  created() {
          console.log(this.$user.uid)

    this.$db.collection('institutions').get().then(({ docs }) => {
      this.institutionList = docs.map((doc) => ({ name: doc.data().name, value: doc.id }));
    });
  }
}
</script>
